import { render, staticRenderFns } from "./PopupProjectWrite.vue?vue&type=template&id=63cf135b"
import script from "./PopupProjectWrite.vue?vue&type=script&lang=js"
export * from "./PopupProjectWrite.vue?vue&type=script&lang=js"
import style0 from "./PopupProjectWrite.vue?vue&type=style&index=0&id=63cf135b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports